import type { SponsoredProduct } from './interfaces/sponsoredProduct';

export const FETCHING_SPONSORED_PRODUCTS =
  'productDiscovery/sponsoredProduct/FETCHING';
export const FETCH_SPONSORED_PRODUCTS_SUCCESS =
  'productDiscovery/sponsoredProduct/FETCH_SUCCESS';
export const FETCH_SPONSORED_PRODUCTS_FAILED =
  'productDiscovery/sponsoredProduct/FETCH_FAILED';

export interface FetchingSponsoredProducts {
  type: typeof FETCHING_SPONSORED_PRODUCTS;
}

export const fetchingSponsoredProducts = (): FetchingSponsoredProducts => ({
  type: FETCHING_SPONSORED_PRODUCTS,
});

export interface FetchSponsoredProductsSuccess {
  type: typeof FETCH_SPONSORED_PRODUCTS_SUCCESS;
  sponsoredProducts: SponsoredProduct[];
  positions: number[];
}

export const fetchSponsoredProductsSuccess = (
  sponsoredProducts: SponsoredProduct[],
  positions: number[],
): FetchSponsoredProductsSuccess => ({
  type: FETCH_SPONSORED_PRODUCTS_SUCCESS,
  sponsoredProducts,
  positions,
});

export interface FetchSponsoredProductsFailed {
  type: typeof FETCH_SPONSORED_PRODUCTS_FAILED;
  error: Error;
}

export const fetchSponsoredProductsFailed = (
  error: Error,
): FetchSponsoredProductsFailed => ({
  type: FETCH_SPONSORED_PRODUCTS_FAILED,
  error,
});

export type Action =
  | FetchingSponsoredProducts
  | FetchSponsoredProductsSuccess
  | FetchSponsoredProductsFailed;
